import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Measure from 'react-measure';
import { getAllPartners, getPartnerClients } from 'redux/modules/partners';
import { browserHistory } from 'react-router';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import { ListItem } from 'material-ui/List';
import { LeftNavLayout } from 'containers';
import { DataTable, PageHeader, SelectableList, Spinner } from 'components';
import * as styles from './Partners.scss';
var PartnerClients = (_dec = connect(function (state) {
  return {
    organization: state.organization.current,
    theme: state.theme,
    allPartners: state.partners.allPartners,
    partnerClients: state.partners.partnerClients,
    gettingPartnerClients: state.partners.gettingPartnerClients,
    partnerSearchResults: state.partners.partnerSearchResults
  };
}, {
  getAllPartners: getAllPartners,
  getPartnerClients: getPartnerClients
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(PartnerClients, _Component);

  var _super = _createSuper(PartnerClients);

  function PartnerClients(props) {
    var _this;

    _classCallCheck(this, PartnerClients);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleRowSelection", function (selectedRows) {
      browserHistory.push({
        pathname: "/global/partners/".concat(_this.props.params.partnerId, "/client/").concat(selectedRows.orgId)
      });
    });

    _this.state = {
      height: 100
    };
    return _this;
  }

  _createClass(PartnerClients, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.allPartners && !this.props.allPartners.length) {
        this.props.getAllPartners();
      }

      if (this.props.partnerClients && !this.props.partnerClients.hasOwnProperty(this.props.params.partnerId)) {
        this.props.getPartnerClients(this.props.params.partnerId);
      }
    }
    /** *******************************************************************************************
     EVENT HANDLERS
    ********************************************************************************************/

  }, {
    key: "render",
    value:
    /** *******************************************************************************************
     RENDER
    ********************************************************************************************/
    function render() {
      var _this2 = this;

      var partnerList = _toConsumableArray(this.props.partnerSearchResults || []);

      var listValue = (this.props.partnerSearchResults || []).findIndex(function (partner) {
        return "".concat(partner.orgId) === "".concat(_this2.props.params.partnerId);
      });

      if (listValue === -1) {
        listValue = this.props.allPartners.findIndex(function (partner) {
          return "".concat(partner.orgId) === "".concat(_this2.props.params.partnerId);
        });
        partnerList = _toConsumableArray(this.props.allPartners);
      }

      console.log('listValue', listValue);
      return /*#__PURE__*/React.createElement(LeftNavLayout, {
        sidebar: "admin",
        wrapStyle: {
          flex: '1 1 auto',
          padding: 0
        },
        appLayoutInnerStyle: {
          display: 'flex',
          flex: '1 1 auto',
          padding: 0,
          overflow: 'hidden',
          height: '100%'
        }
      }, /*#__PURE__*/React.createElement(Helmet, {
        title: "Partners List"
      }), /*#__PURE__*/React.createElement(Measure, {
        whitelist: ['height'],
        onMeasure: function onMeasure(dimensions) {
          _this2.setState({
            height: dimensions.height
          });
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          height: '100%',
          width: '100%'
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: _defineProperty({
          borderRight: '1px solid silver',
          height: '100%',
          overflow: 'hidden',
          overflowY: 'auto'
        }, "height", this.state.height)
      }, partnerList && !!partnerList.length && !this.props.gettingAllPartners ? /*#__PURE__*/React.createElement(SelectableList, {
        defaultValue: listValue + 1,
        onChange: function onChange() {
          return false;
        },
        style: {
          paddingTop: 0
        }
      }, partnerList.map(function (partner, index) {
        return /*#__PURE__*/React.createElement(ListItem, {
          key: index,
          value: index + 1,
          primaryText: partner.name,
          onClick: function onClick() {
            _this2.setState({
              listItem: index
            });

            browserHistory.push({
              pathname: "/global/partners/".concat(partner.orgId)
            });
          }
        });
      })) : /*#__PURE__*/React.createElement("div", {
        style: {
          position: 'relative',
          height: 75
        }
      }, /*#__PURE__*/React.createElement(Spinner, {
        center: true
      }))), this.props.gettingPartnerClients && /*#__PURE__*/React.createElement("div", {
        style: {
          flex: '1 1 auto'
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          position: 'relative',
          height: 75
        }
      }, /*#__PURE__*/React.createElement(Spinner, {
        center: true
      }))), /*#__PURE__*/React.createElement("div", {
        style: {
          overflow: 'hidden',
          overflowY: 'auto'
        }
      }, this.props.partnerClients && this.props.partnerClients.hasOwnProperty(this.props.params.partnerId) && !this.props.gettingPartnerClients && /*#__PURE__*/React.createElement(DataTable, {
        stickyHeader: true,
        noRowClasses: true,
        firstColColored: true,
        headerFields: [{
          name: 'ID',
          key: 'orgId'
        }, {
          name: 'Client Name',
          key: 'name'
        }, {
          name: 'Owner',
          key: 'fullName'
        }, {
          name: 'Email',
          key: 'email'
        }],
        data: this.props.partnerClients[this.props.params.partnerId],
        fixedHeader: true,
        height: 500,
        onRowSelection: this.handleRowSelection,
        style: {
          padding: '8px 24px',
          flex: '1 1 auto'
        }
      })))));
    }
  }]);

  return PartnerClients;
}(Component)) || _class);
export { PartnerClients as default };